<template>
  <div id="app">
    <Header />
    <Page no-image>
      <div class="pb-8 px-content pt-8">
        <h2 class="subheadline">Für draußen gemacht</h2>
        <div class="flex justify-center">
          <h1 class="headline">Außentreppen</h1>
        </div>

        <p class="mt-4 font-semibold text-gray-800">
          Die erste Stufe in den Garten. Der Weg zur Terrasse. Der Zugang zum Keller oder die Verbindung zum Obergeschoss im Anbau. Außentreppen sind täglich im Einsatz. Und das bei jedem Wetter. Deshalb bauen wir Treppen, die nicht nur halten, was sie versprechen, sondern auch optisch zum Haus passen und auf lange Sicht überzeugen.
        </p>

        <p class="mt-4 text-gray-700">
          Gerade oder gewendelte Wangentreppen, platzsparende Holmtreppen oder robuste Spindeltreppen – wir fertigen jede Außentreppe exakt nach Maß. Bei der Wahl der Stufen bieten wir verschiedene Lösungen: Gitterroststufen für höchste Rutschsicherheit, elegante Granitstufen für eine hochwertige Optik oder gekantete Blechstufen, die bauseitig mit Holz oder WPC belegt werden können – für eine warme, wohnliche Anmutung.
        </p>

        <p class="mt-4 text-gray-700">
          Alle unsere Treppen sind feuerverzinkt und auf Wunsch zusätzlich pulverbeschichtet – für maximalen Korrosionsschutz und gestalterische Vielfalt. Ob modern, klassisch oder funktional, Ihre Außentreppe wird mit uns zu einer sicheren, langlebigen und stilvollen Lösung. Jeden Tag. Bei jedem Wetter.
        </p>

        <PhotoGallery :images="images" class="mt-8 mb-4" />
      </div>

      <ProduktKontaktformular product="Außentreppen" pixelEvent="FormAussentreppenSent" />
      <CallToAction />
    </Page>
    <Footer />
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import CallToAction from "../../components/CallToAction.vue";
import Page from "../../components/Page.vue";
import ProduktKontaktformular from "../../components/ProduktKontaktformular.vue";
import PhotoGallery from "../../components/PhotoGallery.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    CallToAction,
    Page,
    ProduktKontaktformular,
    PhotoGallery,
  },
  data() {
    return {
      images: [
        { src: "img/produkte/aussentreppen/1.jpg", alt: "Außentreppe 1" },
        { src: "img/produkte/aussentreppen/2.jpg", alt: "Außentreppe 2" },
        { src: "img/produkte/aussentreppen/3.jpg", alt: "Außentreppe 3" },
        { src: "img/produkte/aussentreppen/4.jpg", alt: "Außentreppe 4" },
        { src: "img/produkte/aussentreppen/5.jpg", alt: "Außentreppe 5" },
        { src: "img/produkte/aussentreppen/6.jpg", alt: "Außentreppe 6" },
        { src: "img/produkte/aussentreppen/7.jpg", alt: "Außentreppe 7" },
        { src: "img/produkte/aussentreppen/8.jpg", alt: "Außentreppe 8" },
        { src: "img/produkte/aussentreppen/9.jpg", alt: "Außentreppe 9" },
        { src: "img/produkte/aussentreppen/10.jpg", alt: "Außentreppe 10" },
        { src: "img/produkte/aussentreppen/11.jpg", alt: "Außentreppe 11" },
        { src: "img/produkte/aussentreppen/12.jpg", alt: "Außentreppe 12" },
        { src: "img/produkte/aussentreppen/13.jpg", alt: "Außentreppe 13" },
      ],
    };
  },
};
</script>

<style src="../../assets/css/comfortaa.css"></style>
<style src="../../assets/css/styles.css"></style>
